app.controller('patientActiveVisitController', ['$rootScope', '$interval', '$controller', '$scope', 'config', '$timeout',
    '$state', '$stateParams', '$mdDialog', '$mdMenu', '$translate', '$injector', 'objectHelper', 'baseModel', 'applicationModel', 'patientModel',
    'userModel', 'icdModel', 'dictionaryModel', 'visitModel', 'visitCardModel', 'prescriptionModel', 'referralModel', 'sickLeaveModel',
    'p2DrugModel', 'insuranceStatementModel', 'laboratoryTestResultModel', 'prescribedDrugModel', 'diagnosisModel', 'medicalProcedureModel',
    'meedy.userModel', 'heartEchoModel', 'referralToClinicModel',
    function ($rootScope, $interval, $controller, $scope, config, $timeout, $state, $stateParams, $mdDialog, $mdMenu,
              $translate, $injector, objectHelper, baseModel, applicationModel, patientModel, userModel, icdModel, dictionaryModel,
              visitModel, visitCardModel, prescriptionModel, referralModel, sickLeaveModel, p2DrugModel, insuranceStatementModel,
              laboratoryTestResultModel, prescribedDrugModel, diagnosisModel, medicalProcedureModel, meedyUserModel, heartEchoModel, referralToClinicModel) {

        angular.extend(this, $controller('baseVisitCardController', {$scope: $scope}));

        var listeners = {};

        var visitCardWatcherAdded = false;

        function initVisitCard() {
            $scope.visitInitialized = true;
            if ($scope.visit.visitStatus === Enum.VISIT_STATUS.PLANNED) {
                visitModel.begin($scope.visit.id).then(listeners.onVisitBegin);
            } else if ($scope.visit.visitStatus === Enum.VISIT_STATUS.IN_PROGRESS || $scope.visit.visitStatus === Enum.VISIT_STATUS.SUSPENDED) {
                //visitCardModel.loadAutoSave($scope.visit.visitCard.id).then(listeners.onLoadAutoSave);

                visitCardModel.getById($scope.visit.visitCard.id).then(listeners.onVisitCardGetById);
            } else {
                if (!$scope.visitCardCorrection) {
                    $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD_CORRECT, {visitId: $stateParams.visitId});
                } else {
                    visitCardModel.getById($scope.visit.visitCard.id).then(listeners.onVisitCardGetById);
                }
            }

            if(!$scope.lastPatientVisit && $scope.visit.doctor) {
                if(userModel.currentUser.userType === 'DOCTOR') {
                    visitModel.getLastVisitForPatient($stateParams.patientId, $scope.doctorId);
                } else {
                    visitModel.getLastVisitForPatient($stateParams.patientId, $scope.visit.doctor.id);
                }
            }
            if ($scope.visit.id) {
                visitModel.getZM($scope.visit.id);
            }
        }

        function updateMainAffliction() {
            $scope.visitCard.diagnosisList.forEach(function (diagnosis, index) {
                if (diagnosis.mainAffliction) {
                    if ($scope.visitCard.sickLeave && !$scope.visitCard.sickLeave.id) {
                        $scope.visitCard.sickLeave.icd10 = diagnosis.icd10;
                    }
                }

            });
        }

        function beforeSave() {
            if($scope.visit.visitStatus === Enum.VISIT_STATUS.IN_PROGRESS) {
                updateMainAffliction();
            }
        }

        function checkForUnprintedDocuments() {
            var unprintedDocs = false;

            if(!unprintedDocs && $scope.visitCard.prescriptions.length) {
                $scope.visitCard.prescriptions.forEach(function(prescription) {
                    if(!prescription.id && !unprintedDocs) {
                        unprintedDocs = true;
                    }
                })
            }

            if(!unprintedDocs && $scope.visitCard.referrals.length) {
                $scope.visitCard.referrals.forEach(function(referral) {
                    if(!referral.id && !unprintedDocs) {
                        unprintedDocs = true;
                    }
                })
            }

            if(!unprintedDocs && $scope.visitCard.sickLeave) {
                if(!$scope.visitCard.sickLeave.id && !unprintedDocs) {
                    unprintedDocs = true;
                }
            }

            return unprintedDocs;
        }

        function setData() {
            $scope.doctorId = userModel.getCurrentContextDoctorId();
            $scope.nfzContracts = meedyUserModel.currentUser.nfzContracts;

            // fixme
            $scope.$parent.$parent.visitCardMode = 'fill';
            $scope.selectedTabIndex = 0;

            $scope.forms = {
                activeVisitForm: null
            };

            $scope.actionInProgress = false;
            $scope.localOtcDrugs = [];

            $scope.autoSaving = false;
            $scope.autoSavingWithTimeout = false;

            // wtf?
            $scope.notFilledWarning = $translate.instant('T.MODULE.VISIT.NOT_FILLED');

            $scope.patientAllergies = [];
            $scope.patientDiagnosis = [];
            $scope.patientChronicallyTakenDrugs = [];
            $scope.lastPatientVisit = null;

            $scope.userHasRightForICF = userModel.userHasRight(Constant.RIGHT.ICF_CREATE);

            if($injector.has('meedy.userModel')) {
                $scope.userHasRightForALAB = $injector.get('meedy.userModel').userHasRightForALAB;
            }

            if($state.current.name === Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD_CORRECT) {
                $scope.visitCardCorrection = true;
            }

            $scope.zm = null;
        }

        function setPermissions() {
        }

        function setListeners() {
            if($injector.has('meedy.userModel') && Event.MEEDY) {
                $scope.$on(Event.MEEDY.USER.ALAB_INTEGRATION_AVAILABLE.SUCCESS, function (event, value) {
                    $scope.userHasRightForALAB = value;
                });
            }

            $scope.$on(Event.PATIENT.GET_STATE_OF_HEALTH.SUCCESS, function (event, stateOfHealth) {
                $scope.patientStateOfHealth = stateOfHealth;

                $scope.patientAllergies = [];
                $scope.patientDiagnosis = [];
                $scope.patientChronicallyTakenDrugs = [];
                $scope.patientChronicallyIllnesses = [];

                $scope.patientAllergies = stateOfHealth.allergies.data.filter(function(allergy) {
                    return allergy.type === Enum.ALLERGY_TYPE.DRUGS;
                });

                $scope.patientDiagnosis = stateOfHealth.chronicDiagnosis.data.filter(function(diagnosis) {
                    return diagnosis.chronic;
                });

                $scope.patientChronicallyTakenDrugs = stateOfHealth.takenDrugs.data.filter(function(takenDrug) {
                    return takenDrug.chronic;
                });

                $scope.patientChronicallyIllnesses = stateOfHealth.chronicDiagnosis.data.filter(function(illness) {
                    return illness.chronicAffliction;
                });

            });

            $scope.$on(Event.VISIT.GET_LAST_VISIT_FOR_PATIENT.SUCCESS, function(event, visit) {
                $scope.lastPatientVisit = visit;
            });

            listeners.onVisitCardGetById = function (visitCard) {
                $scope.visitCard = visitCard;
                $scope.visitCard.visit = new VisitVO($scope.visit.id);
                $scope.visit.visitCard = visitCard;

                if($scope.visit.visitType == Enum.MEEDY.TERM_TYPE.PRESCRIPTION) {
                    $scope.openMedicalTemplatePopup(Enum.PRESCRIPTION_TYPE.RP);
                }
                if ($scope.edmVisit.id) {
                    visitModel.getZM($scope.edmVisit.id);
                }
            };

            listeners.onVisitBegin = function (visit) {
                $scope.$parent.visit = visit;
                $scope.visit = visit;
                $scope.visitCard = visit.visitCard;
                $scope.visitCard.visit = new VisitVO(visit.id);

                if($scope.visit.visitType == Enum.MEEDY.TERM_TYPE.PRESCRIPTION) {
                    $scope.visitCard.reconnaissance = "RP";
                    $scope.visitCard.physicalExamination = "RP";
                    $scope.visitCard.recommendations = "RP";
                    $scope.updateTextFields();

                    $scope.openMedicalTemplatePopup(Enum.PRESCRIPTION_TYPE.RP);
                }
            };

            listeners.onLoadAutoSave = function (visitCard) {
                if(visitCard) {
                    $scope.visit.visitCard = visitCard;
                    $scope.visitCard = visitCard;
                    $scope.visitCard.visit = new VisitVO($scope.visit.id);
                } else {
                    visitCardModel.getById($scope.visit.visitCard.id).then(listeners.onVisitCardGetById);
                }
            };

            listeners.onVisitClose = function () {
                $scope.actionInProgress = false;
                $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD_VIEW, { patientId: $scope.patient.id, visitId: $scope.visit.id, forceVisitUpdate: true });
            };

            listeners.onVisitCardUpdate = function () {
                $scope.actionInProgress = false;
                $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD_VIEW, { patientId: $scope.patient.id, visitId: $scope.visit.id, forceVisitUpdate: true });
            };

            if(!$scope.$parent.visit) {
                // fixme try to fix it - it's an ugly solution
                var disabler = $scope.$watch('$parent.visit', function (newVal) {
                    if(newVal) {
                        $scope.visit = newVal;
                        initVisitCard();
                        disabler();
                    }
                });
            }

            listeners.onLaboratoryTestALABResult = function(dataPage) {
                $scope.patientLaboratoryTests = dataPage.data;
            };

            $scope.$on(Event.VISIT.GET_ZM.SUCCESS, function(event, data) {
                $scope.zm = data;
            });

            $scope.$on(Event.VISIT.SEND_ZM.SUCCESS, function(event, data) {
                visitModel.getZM($scope.visit.id);
            });

        }

        function setActions() {

            $scope.updateTextFields = function (ev, input) {
                if($scope.visit.visitStatus === Enum.VISIT_STATUS.IN_PROGRESS) {
                    $scope.autoSavingWithTimeout = true;
                    var visitCardTextFieldsWrapper = new VisitCardTextFieldsWrapperVO();
                    visitCardTextFieldsWrapper.reconnaissance = $scope.visitCard.reconnaissance;
                    visitCardTextFieldsWrapper.physicalExamination = $scope.visitCard.physicalExamination;
                    visitCardTextFieldsWrapper.recommendations = $scope.visitCard.recommendations;
                    visitCardModel.updateTextFields($scope.visitCard.id, visitCardTextFieldsWrapper).then(function() {
                        $timeout(function() {
                            $scope.autoSavingWithTimeout = false;
                        }, 800)
                    })
                }
            };

            $scope.enclose = function (fileInput) {
                if(fileInput.length > 0) {
                    fileInput.forEach(function(element) {
                        var file = objectHelper.o(AttachmentFileVO, { fileName: element.name, documentExternalId: element, createDate: new Date()});
                        $scope.visitCard.attachment.attachmentFiles.push(file);
                    });
                }
            };

            $scope.switchVisitTypeToICF = function () {
                $scope.visit.visitType = Enum.VISIT_TYPE.ICF;
                visitModel.update($scope.visit).then(function (savedData) {
                    $scope.visit = savedData;
                });
            };

            //fixme trzeba zrobić usuwanie dla attachmentów, recept -
            $scope.deleteAttachedDocument = function(array, prescription, modelType) {
                if(prescription.p1Prescription){
                    var configPopup = {
                        templateUrl: 'edm/application/view/app/patient/popup/activeVisit/popup-sign-prescription.html',
                        controller: 'popupSignPrescriptionController',
                        controllerAs: 'signPrescriptionCtrl',
                        skipHide: true,
                        locals: {
                            $scope: $scope,
                            $mdDialog: $mdDialog,
                            title: 'Podpisz anulację certyfikatem ZUS',
                            message: 'Podaj hasło do certyfikatu',
                            altButtons: true
                        }
                    };

                    $mdDialog.show(configPopup).then(function(password) {
                        if(password) {
                            prescriptionModel.eDelete(prescription, password).then(function(response) {
                                visitCardModel.getById($scope.visit.visitCard.id).then(listeners.onVisitCardGetById);
                            }).catch( function() {
                                $mdDialog.show({
                                    templateUrl: 'edm/application/view/app/popup/popup-error.html',
                                    controller: 'popupErrorController',
                                    skipHide: true,
                                    resolve: {
                                        error: function () {
                                            return {
                                                title: 'Wystąpił błąd podczas anulacji e-recepty',
                                                message: 'W celu anulacji e-recepty należy podać prawidłowe hasło oraz uzupełnić wszystkie dane: osobowe, placówki i gabinetu. Trzeba także wgrać wymagane certyfikaty'
                                            };
                                        }
                                    }
                                });
                            });
                        }
                    });

                } else {
                    var confirm = $mdDialog.confirm({
                        title: $translate.instant('T.MODULE.VISIT.DOCUMENT_DELETE_CONFIRMATION'),
                        ok: $translate.instant('T.UI.APPLICATION.YES'),
                        cancel: $translate.instant('T.UI.APPLICATION.NO')
                    });
                    $mdDialog.show(confirm).then(function() {
                        if(array) {
                            _.remove(array, function (file) {
                                return file === prescription
                            });
                        }

                        var model = function() {
                            switch(modelType) {
                                case 'prescription':
                                    return prescriptionModel;
                                case 'referral':
                                    return referralModel;
                                case 'insurance':
                                    return insuranceStatementModel;
                                case 'sickLeave':
                                    return sickLeaveModel;
                            }
                        }();

                        if(model && model.delete) {
                            model.delete(prescription).then(function() {
                                visitCardModel.getById($scope.visit.visitCard.id).then(listeners.onVisitCardGetById);
                            })
                        }
                    }, function() {
                        return false;
                    });
                }
            };

            $scope.printPrescription = function (prescription) {
                if(prescription.p1Prescription) {
                    visitCardModel.getP1ById(prescription.id)
                        .then(function(prescriptionHTML) {
                            var newWindow = window.open();
                            newWindow.document.body.innerHTML = prescriptionHTML;
                            newWindow.focus();
                            newWindow.print();
                        });
                } else {
                    prescriptionModel.downloadPDF(prescription.id).then(function(link) {
                        visitCardModel.getById($scope.visit.visitCard.id).then(listeners.onVisitCardGetById);
                        window.open(link, '_blank');
                        window.focus();
                    });
                }
            };

            $scope.printReferral = function (referral) {
                referralModel.downloadPDF(referral.id).then(function(link) {
                    visitCardModel.getById($scope.visit.visitCard.id).then(listeners.onVisitCardGetById);
                    window.open(link, '_blank');
                    window.focus();
                });
            };

            $scope.getHeartEchoPDF = function (id, print) {
                heartEchoModel.getPDF(id).then(function(link) {
                    var heartEchoPreview = window.open(link, '_blank');
                    heartEchoPreview.focus();
                    if (print) {
                        heartEchoPreview.print();
                    }
                });

            };

            $scope.printSickLeave = function () {
                sickLeaveModel.downloadPDF($scope.visitCard.sickLeave.id).then(function(link) {
                    visitCardModel.getById($scope.visit.visitCard.id).then(listeners.onVisitCardGetById);
                    window.open(link, '_blank');
                    window.focus();
                });
            };

            $scope.deleteHeartEcho = function (id) {
                heartEchoModel.delete(id).then(function() {
                    visitCardModel.getById($scope.visit.visitCard.id).then(listeners.onVisitCardGetById);
                });
            };

            $scope.deleteClinicReferral = function (id) {
                referralToClinicModel.delete(id).then(function() {
                    visitCardModel.getById($scope.visit.visitCard.id).then(listeners.onVisitCardGetById);
                });
            };

            $scope.closeVisit = function() {
                beforeSave();
                $scope.forms.activeVisitForm.$setSubmitted();

                if($scope.forms.activeVisitForm.$valid && !$scope.actionInProgress) {
                    $scope.visit.visitCard = $scope.visitCard;

                    $scope.actionInProgress = true;
                    if(!$scope.visitCardCorrection) {
                        visitModel.complete($scope.visit).then(listeners.onVisitClose);
                    } else {
                        visitCardModel.update($scope.visitCard).then(listeners.onVisitCardUpdate);
                    }
                }
            };

            $scope.saveVisitDataAndLeave = function() {
                if(checkForUnprintedDocuments()) {
                    $scope.actionInProgress = true;
                    var confirm = $mdDialog.confirm({
                        title: $translate.instant('T.MODULE.VISIT.VISIT_SAVE_AND_LEAVE_CONFIRMATION'),
                        ok: $translate.instant('T.UI.APPLICATION.YES'),
                        cancel: $translate.instant('T.UI.APPLICATION.NO')
                    });
                    $mdDialog.show(confirm).then(function() {
                        suspendVisit();
                    }, function() {
                        $scope.actionInProgress = false;
                        return false;
                    });
                } else {
                    suspendVisit();
                }

                function suspendVisit() {
                    var date = new Date($scope.visit.date.getTime());
                    date.setHours(0,0,0,0);

                    $state.go(Constant.STATE.APP.MEEDY.CALENDAR.INDEX, { date: date.getTime(), resourceId: 0 });
                }
            };

            $scope.previewVisitEpicrisis = function() {
                visitCardModel.previewPDF($scope.visitCard.id);
            };

            $scope.deleteSickLeave = function () {
                $scope.visitCard.sickLeave = null;
            };


            /**
             * @deprecated
             */
            $scope.openIcfGraph = function (data) {
                var flag = false;
                var icfData = [];

                flag = data.every(function(element) {
                    return element.icfDiagnosis.firstQualifier != null;
                });

                if(flag) {
                    data.every(function (element) {
                        return icfData.push(element.icfDiagnosis);
                    });

                    $mdDialog.show({
                        templateUrl: 'edm/application/view/app/patient/popup/activeVisit/popup-icf-graph.html',
                        controller: 'popupIcfGraphController',
                        resolve: {
                            icfDiagnosis: function() {
                                return icfData;
                            }
                        }
                    })
                } else {
                    $scope.alert(null, $translate.instant('T.MODULE.VISIT.FILL_ALL_QUALIFIERS_TO_SEE_REPORT'));
                }

            };

            /**
             * @deprecated
             */
            $scope.openStateOfHealthSimulation = function () {
                var icfDiagnoses = _.map($scope.localIcfDiagnosisList, 'icfDiagnosis');
                var eachIcfDiagnosisHasFilledFirstQualifier = icfDiagnoses.every(function(diagnosis) {
                    return diagnosis.firstQualifier != null;
                });

                if(!eachIcfDiagnosisHasFilledFirstQualifier || !$scope.visitCard.medicalProcedures.length) {
                    $scope.alert(null, $translate.instant('T.MODULE.VISIT.FILL_ALL_QUALIFIERS_AND_AT_LEAST_ONE_ICD9_TO_SEE_SIMULATION'));
                    return;
                }

                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-stateOfHealthSimulation.html',
                    controller: 'popupStateOfHealthSimulationController',
                    resolve: {
                        visitCardId: function() {
                            return $scope.visitCard.id;
                        },
                        icfDiagnoses: function() {
                            return icfDiagnoses;
                        }
                    }
                });
            };

            /**
             * @deprecated
             */
            $scope.openTreatmentCostSimulation = function () {
                var icfDiagnoses = _.map($scope.localIcfDiagnosisList, 'icfDiagnosis');

                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-treatmentCostSimulation.html',
                    controller: 'popupTreatmentCostSimulationController',
                    resolve: {
                        visitCardId: function() {
                            return $scope.visitCard.id;
                        },
                        icfList: function() {
                            return _.map(icfDiagnoses, 'icf');
                        }
                    }
                });
            };


            $scope.selectDosageForDrugs = function () {
                var allDrugs = [];

                if($scope.visitCard.prescribedDrugs && $scope.visitCard.prescribedDrugs.length) {
                    allDrugs = $scope.visitCard.prescribedDrugs.filter(function(drug) {
                        return !drug.deleted;
                    })
                }

                if(!allDrugs.length) {
                    $scope.alert($translate.instant('T.MODULE.VISIT.FUNCTION_AVAILABLE_AFTER_DRUGS_ADDED'));
                    return false;
                }

                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-drugs-dosage.html',
                    controller: 'popupDrugsDosageController',
                    resolve: {
                        prescribedDrugs: function() {
                            return allDrugs;
                        }
                    }
                }).then(function(data) {
                    if($scope.visit.visitStatus === Enum.VISIT_STATUS.IN_PROGRESS) {
                        prescribedDrugModel.updateDosageDescriptions(data).then(function() {
                            visitCardModel.getById($scope.visit.visitCard.id).then(listeners.onVisitCardGetById);
                        })
                    } else {
                        var deletedDrugs = $scope.visitCard.prescribedDrugs.filter(function(d) { return d.deleted });
                        var newDrugsArray = deletedDrugs.concat(data);
                        $scope.visitCard.prescribedDrugs = angular.copy(newDrugsArray);
                    }
                })
            };

            $scope.getEpicrisisForLastPatientVisit = function () {
                visitCardModel.downloadPDF($scope.lastPatientVisit.visitCard.id);
            };

            $scope.openInsuranceStatement = function (insuranceType, insurance) {
                if($scope.visitCard.diagnosisList.length <= 0) {
                    $scope.alert(null, $translate.instant('T.MODULE.VISIT.NO_DIAGNOSIS_ADDED'));
                    return false;
                }

                var templateConfig = {
                    templateUrl: 'edm/application/view/app/patient/popup/activeVisit/popup-insurance-statement-n9.html',
                    controller: 'popupInsuranceStatementController',
                    resolve: {
                        visit: function() {
                            return $scope.visit;
                        },
                        diagnosisList: function() {
                            return angular.copy($scope.visitCard.diagnosisList);
                        },
                        patient: function() {
                            return $scope.patient;
                        },
                        insuranceStatementType: function() {
                            return insuranceType
                        },
                        insurance: function() {
                            return insurance;
                        },
                        previewOnly: function() {
                            return (insurance && insurance.alreadyPrinted);
                        }
                    }
                };
                if(insuranceType === Enum.INSURANCE_STATEMENT_TYPE.N14) {
                    templateConfig.templateUrl = 'edm/application/view/app/patient/popup/activeVisit/popup-insurance-statement-n14.html';
                }
                $mdDialog.show(templateConfig).then(function(returnedObjectInsuranceStatement) {
                    visitCardModel.getById($scope.visit.visitCard.id).then(listeners.onVisitCardGetById);
                }, function(error) {

                })
            };

            $scope.printInsuranceStatement = function (insuranceStatement) {
                if(insuranceStatement.id) {
                    download(insuranceStatement);

                } else {
                    insuranceStatementModel.save(insuranceStatement).then(function(ref) {
                        download(ref);
                    });
                }

                function download(obj) {
                    insuranceStatementModel.downloadPDF(obj.id).then(function(link) {
                        window.open(link, '_blank');
                        window.focus();
                        visitCardModel.getById($scope.visit.visitCard.id).then(listeners.onVisitCardGetById);
                    })
                }
            };

            $scope.updateLaboratoryTestResult = function(laboratoryTestResult) {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-laboratoryTestResult.html',
                    controller: 'popupLaboratoryTestResultUpdateController',
                    resolve: {
                        laboratoryResultToUpdate: function() {
                            return laboratoryTestResult;
                        },
                        preview: function() {
                            return false;
                        }
                    }
                }).then(function (data) {
                    laboratoryTestResultModel.getDataPage({idPatient: $stateParams.patientId, needsAnalysis: true}).then(listeners.onLaboratoryTestALABResult);
                }, function () {
                    //cancel
                });
            };


            $scope.extendVisitCardForTemplate = function(template) {
                var savedDiagnoses = [];
                var savedProcedures = [];
                var savedDrugs = [];

                if(template.physicalExamination || template.recommendations || template.reconnaissance) {
                    if(!$scope.visitCard.physicalExamination) {
                        $scope.visitCard.physicalExamination = '';
                        $scope.visitCard.physicalExamination += template.physicalExamination;
                    } else {
                        $scope.visitCard.physicalExamination += template.physicalExamination;
                    }

                    if(!$scope.visitCard.recommendations) {
                        $scope.visitCard.recommendations = '';
                        $scope.visitCard.recommendations += template.recommendations;
                    } else {
                        $scope.visitCard.recommendations += template.recommendations;
                    }

                    if(!$scope.visitCard.reconnaissance) {
                        $scope.visitCard.reconnaissance = '';
                        $scope.visitCard.reconnaissance += template.reconnaissance;
                    } else {
                        $scope.visitCard.reconnaissance += template.reconnaissance;
                    }

                    $scope.updateTextFields();
                }

                if(template.diagnosisList.length) {
                    var mainDiagnosisDefined = $scope.visitCard.diagnosisList.some(function(d) { return d.mainAffliction });

                    if(mainDiagnosisDefined) {
                        template.diagnosisList.forEach(function(diagnosis) {
                            diagnosis.mainAffliction = false;
                        })
                    }

                    template.diagnosisList.forEach(function(diagnosis) {
                        diagnosisModel.save(assignIdsToEntity(diagnosis)).then(function(newDiagnosis) {
                            savedDiagnoses.push(newDiagnosis);

                            if(savedDiagnoses.length === template.diagnosisList.length) {
                                $scope.visitCard.diagnosisList = $scope.visitCard.diagnosisList.concat(savedDiagnoses);
                            }
                        })
                    });

                }
                if(template.medicalProcedures.length) {
                    template.medicalProcedures.forEach(function(medicalProcedure) {
                        medicalProcedureModel.save(assignIdsToEntity(medicalProcedure)).then(function(newMedicalProcedure) {
                            savedProcedures.push(newMedicalProcedure);

                            if(savedProcedures.length === template.medicalProcedures.length) {
                                $scope.visitCard.medicalProcedures = $scope.visitCard.medicalProcedures.concat(savedProcedures);
                            }
                        })
                    })
                }

                if(template.prescribedDrugs.length) {
                    template.prescribedDrugs.forEach(function(prescribedDrug) {
                        prescribedDrugModel.save(assignIdsToEntity(prescribedDrug)).then(function(newPrescribedDrug) {
                            savedDrugs.push(newPrescribedDrug);

                            if(savedDrugs.length === template.prescribedDrugs.length) {
                                $scope.visitCard.prescribedDrugs = $scope.visitCard.prescribedDrugs.concat(savedDrugs);
                            }
                        })
                    })

                }

                function assignIdsToEntity(entity) {
                    var newEntity = angular.copy(entity);
                    delete newEntity.id;

                    if(newEntity.drug) {
                        delete newEntity.drug.id;
                    }

                    newEntity.patient = new PatientVO(parseInt($stateParams.patientId));
                    newEntity.visitCard = new VisitCardVO($scope.visitCard.id);
                    return newEntity;
                }

            }

            $scope.sendZM = function() {
                visitModel.sendZM($scope.visit.id);
            };
        }

        function configureInterface() {

        }

        function initialize() {
            patientModel.getStateOfHealth($stateParams.patientId);
            laboratoryTestResultModel.getDataPage({idPatient: $stateParams.patientId, needsAnalysis: true}).then(listeners.onLaboratoryTestALABResult);

            if($injector.has('meedy.userModel') && $injector.get('meedy.userModel').userHasRightForALAB == null) {
                $injector.get('meedy.userModel').alabIntegrationAvailable();
            }

            if($scope.$parent.visit) {
                $scope.visit = $scope.$parent.visit;
                initVisitCard();
            }
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
